<template>
    <div
        v-if="isComponentReady"
        :class="wrapperClasses"
        class="l-ss-c-search-results">
        <section-filters
            v-show="isFiltersBlockVisible"
            :currency="currencyInOffers"
            :filters="filterItems"
            :has-results="hasResults"
            :has-selected="hasFilters"
            :sort-by="sortBy"
            :sort-dest="sortDest"
            :total="totalItemsCount"
            :values="filterValues"
            @change="filters => $emit('filters-change', filters)"
            @sort-change="params => $emit('sort-change', params)"
            @reset-filters="() => $emit('reset-filters')"
            @close-filters="() => toggleFilters(false)"
            @open-filters="() => toggleFilters(true)"/>
        <section-results
            v-if="isResultsVisible"
            ref="search-results"
            :category-id="resultsCategoryId"
            :error-text="errorTextSearch"
            :group-categories="$configuration.features.shouldGroupCategories"
            :has-filters="hasFilters"
            :has-loaded-once="hasLoadedOnce"
            :has-query="hasQuery"
            :has-results="hasResults"
            :is-loading="isSearchLoading"
            :limit="limit"
            :search="searchResponse"
            :search-request-id="searchRequestId"
            :skip="skip"
            :templates="offerTemplates"
            @navigate-category="handleNavigateCategory"
            @navigate-page-next="() => $emit('navigate-page-next')"
            @navigate-page-prev="() => $emit('navigate-page-prev')"
            @reset-category="() => $emit('navigate-category', emitNavigateCategory({ skip: 0, categoryId: '' }))"
            @offer-click="params => $emit('offer-click', params)"
            @add-to-cart="offer => $emit('add-to-cart', offer)"
            @reset-filters="() => $emit('reset-filters')"
            @reset-query="() => $emit('reset-query')"
            @page-reload="handlePageReload"
            @scroll-to-top="handleScrollToTop"/>
    </div>
</template>

<script>
    import { installPlugins } from '../core/plugins';

    import SectionFilters from '../core/components/filters/section-filters';
    import SectionResults from '../core/components/section-results';

    import RootComponentMixin from '../core/mixins/root-component';
    import SearchResultsMixin from '../core/mixins/search-results-mixin';

    installPlugins();

    export default {
        props: {
            ...RootComponentMixin.props,
            ...SearchResultsMixin.props,
        },
        components: {
            SectionFilters,
            SectionResults,
        },
        computed: {
            ...RootComponentMixin.computed,
            ...SearchResultsMixin.computed,
        },
        methods: {
            ...RootComponentMixin.methods,
            ...SearchResultsMixin.methods,
        },
    };
</script>
